import { CheckCircleIcon } from "@heroicons/react/24/solid"

interface Props {
  text: string
  title: string
}

export default function BulletPoint({ text, title }: Props) {
  return (
    <div className="flex items-start gap-4">
      <CheckCircleIcon className="theme-bullet-point h-6 w-6 shrink-0" />

      <div className="flex flex-col gap-1">
        <p className="text-base font-semibold">{title}</p>

        <p className="text-text-secondary text-sm">{text}</p>
      </div>
    </div>
  )
}
